import {
  Divider,
  Typography,
  Input,
  Button,
  DatePicker,
  Tooltip,
  Tabs,
} from "antd";
import { ColumnProps } from "antd/lib/table";
import React, { Fragment, useState, useCallback } from "react";
import PaginatedList from "../list/PaginatedList";
import { IUser } from "../users/models/IUser";
import BugHunterStatisticsPage from "./BugHunterStatisticsPage";

import moment from "moment";
import dayjs from "dayjs";
import {formatDateWithTimezoneOffset} from "../../lib/lib";
import StableDatePicker from "../common/StableDatePicker";
const { Search } = Input;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

const StatisticsPage: React.FC = () => {
  const endpoint = `/api/users/statistics`;

  // State for search query
  const [searchQuery, setSearchQuery] = useState("");

  const currentDate = new Date();
  const firstDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  const lastDayOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  );
  const adjustedfirstDayOfMonth = formatDateWithTimezoneOffset(
    firstDayOfMonth,
    7
  );
  const adjustedlastDayOfMonth = formatDateWithTimezoneOffset(
    lastDayOfMonth,
    7
  );
  const [startDate, setStartDate] = useState<string | null>(
    adjustedfirstDayOfMonth
  );
  const [endDate, setEndDate] = useState<string | null>(adjustedlastDayOfMonth);

  // Thêm state để lưu totals
  const [totals, setTotals] = useState({
    kudosGranted: 0,
    kudosGave: 0,
    giftCost: 0
  });

  const columns: Array<ColumnProps<IUser>> = [
    {
      dataIndex: "realName",
      key: "realName", 
      title: "Tên",
    },
    {
      dataIndex: "teamName",
      key: "teamName",
      title: "Team",
    },
    {
      dataIndex: "kudosGranted",
      key: "kudosGranted",
      title: <Tooltip title={`Tổng: ${totals.kudosGranted.toLocaleString()}`}>
        Sao Đã Nhận
      </Tooltip>,
      sorter: true,
    },
    {
      dataIndex: "kudosGave",
      key: "kudosGave",
      title: <Tooltip title={`Tổng: ${totals.kudosGave.toLocaleString()}`}>
        Sao Đã Tặng
      </Tooltip>,
      sorter: true,
    },
    {
      dataIndex: "giftCost",
      key: "giftCost",
      title: <Tooltip title={`Tổng: ${totals.giftCost.toLocaleString()}`}>
        Sao Quy Đổi
      </Tooltip>,
      sorter: true,
    }
  ];

  const handleSearch = useCallback((value: string) => {
    setSearchQuery(value);
  }, []);

  const handleDateChange = useCallback((dates: [dayjs.Dayjs, dayjs.Dayjs] | null, dateStrings: [string, string]) => {
    if (dates && dateStrings) {
      setStartDate(dateStrings[0] ? formatDateWithTimezoneOffset(dates[0].toDate(), 7) : null);
      setEndDate(dateStrings[1] ? formatDateWithTimezoneOffset(dates[1].toDate(), 7) : null);
    }
  }, []);


  // Thêm hàm xử lý data từ API
  const handleDataLoaded = useCallback((response: any) => {
    if (response.totals) {
      setTotals(response.totals);
    }
  }, []);

  return (
    <Fragment>
      <Typography.Title level={2}>Thống Kê Kudos</Typography.Title>
      <Divider />

      <Tabs defaultActiveKey="1" size="large">
        <TabPane tab="Thống Kê Tổng Quan" key="1">

      {/* Thêm phần hiển thị totals */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '16px',
        marginBottom: '24px'
      }}>
        <div style={{
          padding: '20px',
          background: '#fff',
          borderRadius: '8px',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '14px', color: '#8c8c8c', marginBottom: '8px' }}>
            Tổng Sao Đã Nhận
          </div>
          <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#1890ff' }}>
            {totals.kudosGranted.toLocaleString()}
          </div>
        </div>

        <div style={{
          padding: '20px',
          background: '#fff',
          borderRadius: '8px',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '14px', color: '#8c8c8c', marginBottom: '8px' }}>
            Tổng Sao Đã Tặng
          </div>
          <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#52c41a' }}>
            {totals.kudosGave.toLocaleString()}
          </div>
        </div>

        <div style={{
          padding: '20px',
          background: '#fff',
          borderRadius: '8px',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '14px', color: '#8c8c8c', marginBottom: '8px' }}>
            Tổng Sao Quy Đổi
          </div>
          <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#f5222d' }}>
            {totals.giftCost.toLocaleString()}
          </div>
        </div>
      </div>

          <div style={{ 
            padding: '24px',
            background: '#fff',
            borderRadius: '8px',
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)'
          }}>
        <div style={{ 
          display: 'flex', 
          gap: '16px', 
          marginBottom: '24px',
          flexWrap: 'wrap',
          alignItems: 'center'
        }}>
          <Search
            placeholder="Tìm kiếm theo tên..."
            allowClear
            style={{ width: 300 }}
            onSearch={handleSearch}
          />
          
          <StableDatePicker
            value={startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : null}
            onChange={handleDateChange}
            format="DD/MM/YYYY"
            placeholder={['Từ ngày', 'Đến ngày']}
          />
        </div>

        <PaginatedList
          endpoint={endpoint}
          columns={columns}
          searchQuery={searchQuery}
          startDate={startDate}
          endDate={endDate}
          onDataLoaded={handleDataLoaded}
        />
          </div>
        </TabPane>
        
        <TabPane tab="Thống Kê Bug Hunter" key="2">
          <BugHunterStatisticsPage />
        </TabPane>
      </Tabs>
    </Fragment>
  );
};

export default StatisticsPage; 